import { HttpError } from './http-error';

export async function fetchJsonOrThrow<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const text = await response.text();
    let reason: string | undefined;
    try {
      const parsed = JSON.parse(text) as { reason?: string };
      reason = parsed.reason;
    } catch {
      // body was not JSON — fall back to raw text
    }
    throw new HttpError(
      response.status,
      reason ?? `${response.status} ${response.statusText}: ${text.slice(0, 200)}`,
    );
  }
  return (await response.json()) as T;
}
